export default __webpack_public_path__ + "static/media/tractor-update.66b3aed9.svg";